import { createSelector } from "reselect"
import { pick, chain, get } from "lodash"
import { getAllCategoryItems } from "modules/analyze-factor-sensitivity/selectors/items"
import { getFactorSensitivity } from "modules/analyze-factor-sensitivity/selectors/sensitivity"
import { computeSelected, computeSelectedValue, getLastContributor } from "helpers/contributors"
import { computeFactorSensitivityData } from "helpers/factorSensitivity"

const getSelectedDate = (_, props) => props.selectedDate
const getSelectedRaw = state => get(state, "modules.analyzeFactorSensitivityDetails.selected")

const getAllData = createSelector(
  [getAllCategoryItems, getFactorSensitivity],
  computeFactorSensitivityData,
)

export const getSelected = createSelector(
  [getSelectedRaw, getAllCategoryItems],
  computeSelected,
)

export const getDetails = createSelector(
  [getAllData, getSelectedDate, getAllCategoryItems],
  (data, selectedDate, items) => {
    const lastContributor = getLastContributor(data, selectedDate) || {}

    return chain(items)
      .map(item => ({
        ...pick(item, ["label", "id", "color", "category", "favorite", "field"]),
        value: lastContributor[item.id],
      }))
      .filter(item => item.value || item.favorite)
      .value()
  },
)

export const getSelectedValue = createSelector(
  [getDetails, getSelected],
  computeSelectedValue,
)
